module.exports = __webpack_public_path__ + "img/footer_ins.f1f6016c.svg";